<template>
  <v-layout column>
    <v-flex>
      <v-layout row justify-space-between>
        <v-flex>
          <v-icon>sync</v-icon>
          <h1 class="all-caps subtle d-inline-block mb-2">
            Trade Request
          </h1>
          <h2 class="all-caps font-weight-regular mb-2">
            Scheduled:
            <span class="font-weight-bold"
              >{{ shift.workerName }}</span
            >
          </h2>
          <h2
            v-if="shift.tradeAcceptUserId"
            class="all-caps font-weight-regular"
          >
            New:
            <span class="font-weight-bold"
              >{{ shift.tradeAcceptEmployeeName }}</span
            >
          </h2>
          <h2 v-else class="all-caps font-weight-regular">
            New:
            <span class="subtle"
              >Nobody has taken this trade yet...</span
            >
          </h2>
          <h2
            v-if="shift.tradeReason"
            class="all-caps font-weight-regular"
          >
            Reason for Trade: {{ shift.tradeReason }}
          </h2>
        </v-flex>
        <v-flex shrink class="text-xs-right">
          <v-btn
            block
            @click="allowTrade"
            color="success"
            :disabled="!shift.tradeAcceptUserId"
          >
            <v-icon left>
              thumb_up
            </v-icon>
            Approve
          </v-btn>
          <v-btn block @click="refuseTrade" color="error">
            <v-icon left>
              cancel
            </v-icon>
            deny
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex> </v-flex>
  </v-layout>
</template>

<script>

export default {
  props: [
    'shift',
    'user',
  ],

  methods: {
    allowTrade() {
      this.$store.dispatch('shifts/allowTrade', this.shift.id);
    },
    refuseTrade() {
      this.$store.dispatch('shifts/refuseTrade', this.shift.id);
    },
  }
}
</script>
